// Frittstående admin-vindu (poppet ut). Ingen feed nødvendig — utsteder
// enrolment-koder via /admin/enrol-token (sesjons-cookie, hub håndhever RBAC).
import type { User } from '@skade/rbac';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import { AdminPanel } from '../ui/admin.js';

export function mountAdminPanel(root: HTMLElement, _feed: Feed, _sync: SyncBus, user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const panel = new AdminPanel({ id: user.id, role: user.role, org: user.org });
  panel.el.classList.add('open', 'embedded');
  root.append(panel.el);
}
